import {  DELETE_USER, FETCH_USERS } from "../actions/actionTypes";

var initialState = [];

const findIndex = (data, USER_NO) => {
  var result = -1;
  data.forEach((customer, index) => {
    if (customer.USER_NO === USER_NO) {
      result = index;
    }
  });
  return result;
};

const users = (state = initialState, action) => {
  var index = -1;
  switch (action.type) {
    case FETCH_USERS:
      state = action.data;
      return [...state];
    case DELETE_USER:
      index = findIndex(state, action.USER_NO);
      state.splice(index, 1);
      return [...state];
    default:
      return state;
  }
};

export default users;
